// 1 ) Objeto que se va guardar en el contexto 
const initialState = {
        Modulos : []
};

// 2 ) Logica de manejo de la variable 
const autorizacionModExternalReducer =  (state = initialState, action) =>{
switch (action.type) {
    case "MODULOS_EXTERNAL_AUTORIZACION":
        return{
            ...state,
            Modulos: action.autorizacionModExternal.Modulos
        }
    default : return state; 
}
}; 

//3 se exporta el comporamiento que administra la variable pra poder usarse 
export default autorizacionModExternalReducer;